import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import counties from "@/content/aacogCounties.json";

const BASE_STYLE = { color: "#004778", weight: 1.5, fillColor: "#7EBC37", fillOpacity: 0.25 };
const HOVER_STYLE = { color: "#004778", weight: 2, fillColor: "#C9DA2D", fillOpacity: 0.55 };

export const RegionMap = () => (
  <figure className="mt-10" data-testid="story-region-map">
    <div className="border border-[#004778]/25">
      <MapContainer
        center={[29.35, -98.95]}
        zoom={8}
        style={{ height: 420, width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <GeoJSON
          data={counties}
          style={BASE_STYLE}
          onEachFeature={(feature, layer) => {
            layer.bindTooltip(`${feature.properties.NAME} County`, { sticky: true });
            layer.on({
              mouseover: () => layer.setStyle(HOVER_STYLE),
              mouseout: () => layer.setStyle(BASE_STYLE),
            });
          }}
        />
      </MapContainer>
    </div>
    <figcaption className="mt-3 text-xs italic leading-relaxed text-[#5C6B72]">
      Demonstration map: the 13-county Alamo Area region covered by the climate plan. Hover a
      county to identify it. Production stories can embed HARC's own geospatial data and maps.
    </figcaption>
  </figure>
);
